import angular from 'angular';
import 'angular-ui-router';

import { templatePipeline } from './builder';

let exportConst = '';

exportConst = angular.module('templatesPipeline', [
    templatePipeline,
]).name;

export default exportConst;
